import CopCaseDetails from '../CopCaseDetails/CopCaseDetails'

export type CopCaseDetailsSectionProps = {
  title?: string
  layout?: string

  labels?: string
  tab1label?: string
  tab2label?: string
  tab3label?: string
  addcommentlabel?: string
  popuptitle?: string
  popupdescription?: string
  popuptextareaplaceholder?: string
  popupcharacterlimit?: string
  popupfilehelptext?: string
  popupcancellabel?: string
  popupsharelabel?: string
  popupcommentrequirederror?: string
  popupfiletypeerror?: string
  popupfilesizeerror?: string
  popupfilerequirederror?: string
  popupsubmitsuccessmessage?: string
  popupsubmiterrormessage?: string
  popupselectfilelabel?: string
  popupnofileselectedlabel?: string
  popupcancelconfirmmessage?: string
  popupcancelconfirmyeslabel?: string
  popupcancelconfirmnolabel?: string

  accordionlabels?: string
  collastmodifiedby?: string
  coldate?: string
  colcomments?: string
  colattachments?: string
  colviewdownload?: string
  viewlabel?: string
  downloadlabel?: string
  nocommentslabel?: string
  numberofcommentslabel?: string
  itemsperpagelabel?: string
  loadinglabel?: string
  filedownloaderrorlabel?: string
  resolutionconfig?: string
  cancelconfig?: string
}

export default function CopCaseDetailsSection({
  title,
  layout,
  labels,
  tab1label,
  tab2label,
  tab3label,
  addcommentlabel,
  popuptitle,
  popupdescription,
  popuptextareaplaceholder,
  popupcharacterlimit,
  popupfilehelptext,
  popupcancellabel,
  popupsharelabel,
  popupcommentrequirederror,
  popupfiletypeerror,
  popupfilesizeerror,
  popupfilerequirederror,
  popupsubmitsuccessmessage,
  popupsubmiterrormessage,
  popupselectfilelabel,
  popupnofileselectedlabel,
  popupcancelconfirmmessage,
  popupcancelconfirmyeslabel,
  popupcancelconfirmnolabel,
  accordionlabels,
  collastmodifiedby,
  coldate,
  colcomments,
  colattachments,
  colviewdownload,
  viewlabel,
  downloadlabel,
  nocommentslabel,
  numberofcommentslabel,
  itemsperpagelabel,
  loadinglabel,
  filedownloaderrorlabel,
  resolutionconfig,
  cancelconfig,
}: CopCaseDetailsSectionProps) {
  return (
    <CopCaseDetails
      title={title}
      sectiontype="cases"
      layout={layout}
      labels={labels}
      tab1Label={tab1label}
      tab2Label={tab2label}
      tab3Label={tab3label}
      addCommentLabel={addcommentlabel}
      popupTitle={popuptitle}
      popupDescription={popupdescription}
      popupTextareaPlaceholder={popuptextareaplaceholder}
      popupCharacterLimit={popupcharacterlimit}
      popupFileHelpText={popupfilehelptext}
      popupCancelLabel={popupcancellabel}
      popupShareLabel={popupsharelabel}
      popupCommentRequiredError={popupcommentrequirederror}
      popupFileTypeError={popupfiletypeerror}
      popupFileSizeError={popupfilesizeerror}
      popupFileRequiredError={popupfilerequirederror}
      popupSubmitSuccessMessage={popupsubmitsuccessmessage}
      popupSubmitErrorMessage={popupsubmiterrormessage}
      popupSelectFileLabel={popupselectfilelabel}
      popupNoFileSelectedLabel={popupnofileselectedlabel}
      popupCancelConfirmMessage={popupcancelconfirmmessage}
      popupCancelConfirmYesLabel={popupcancelconfirmyeslabel}
      popupCancelConfirmNoLabel={popupcancelconfirmnolabel}
      accordionLabels={accordionlabels}
      colLastModifiedBy={collastmodifiedby}
      colDate={coldate}
      colComments={colcomments}
      colAttachments={colattachments}
      colViewDownload={colviewdownload}
      viewLabel={viewlabel}
      downloadLabel={downloadlabel}
      noCommentsLabel={nocommentslabel}
      numberOfCommentsLabel={numberofcommentslabel}
      itemsPerPageLabel={itemsperpagelabel}
      loadingLabel={loadinglabel}
      fileDownloadErrorLabel={filedownloaderrorlabel}
      resolutionconfig={resolutionconfig}
      cancelconfig={cancelconfig}
    />
  )
}
